interface BankMovementLinkCellDelegate
{
    linkCellDidTapUnlink(cell:BankMovementLinkCell, link:BankMovementDocumentLink): void;
    linkCellDidTapView(cell:BankMovementLinkCell, link:BankMovementDocumentLink): void;
}

class BankMovementLinkCell extends UITableViewCell
{
    delegate:BankMovementLinkCellDelegate = null;

    private typeLabel:MUILabel = null;
    private nameLabel:MUILabel = null;
    private amountLabel:MUILabel = null;
    private unlinkButton:MUIButton = null;
    private viewButton:MUIButton = null;
    private externalLabel:MUILabel = null;

    // Purchase invoice id -> its external reference, asked once per session (the link doesn't keep it)
    private static externalReferences = {};

    private _link:BankMovementDocumentLink = null;

    awakeFromHTML() {
        this.typeLabel = MUIOutlet(this, "type-lbl", "MUILabel");
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.externalLabel = MUIOutlet(this, "external-lbl", "MUILabel");

        this.unlinkButton = MUIOutlet(this, "unlink-btn", "MUIButton");
        this.unlinkButton.setAction(this, function(this:BankMovementLinkCell){
            if (this.delegate != null && this._link != null) {
                this.delegate.linkCellDidTapUnlink(this, this._link);
            }
        });

        this.viewButton = MUIOutlet(this, "view-btn", "MUIButton");
        this.viewButton.setAction(this, function(this:BankMovementLinkCell){
            if (this.delegate != null && this._link != null) {
                this.delegate.linkCellDidTapView(this, this._link);
            }
        });
        this.viewButton.layer.title = MIOLocalizeString("VIEW_DOCUMENT", "View document");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    // Documents that have a detail to open: not the concepts a difference is allocated to
    static canViewLinkedEntity(entityName:string) : boolean {
        return entityName == "SalesInvoice" || entityName == "LicenseInvoice" || entityName == "PurchaseInvoice";
    }

    static displayNameForLinkedEntity(entityName:string) : string {
        switch (entityName) {
            case "SalesInvoice": return MIOLocalizeString("SALES_INVOICE", "SALES INVOICE");
            case "LicenseInvoice": return MIOLocalizeString("LICENSE_INVOICE", "LICENSE INVOICE");
            case "PurchaseInvoice": return MIOLocalizeString("PURCHASE_INVOICE", "PURCHASE INVOICE");
            case "ArchivedDocument": return MIOLocalizeString("POS_DOCUMENT", "POS DOCUMENT");
            case "ArchivedTicket": return MIOLocalizeString("POS_DOCUMENT", "POS DOCUMENT");
            case "ArchivedInvoice": return MIOLocalizeString("POS_DOCUMENT", "POS DOCUMENT");
            case "EmployeePayroll": return MIOLocalizeString("PAYROLL", "PAYROLL");
            case "Loan": return MIOLocalizeString("LOAN", "LOAN");
            case "BankMovement": return MIOLocalizeString("TRANSFER", "TRANSFER");
            case "BankMovementConcept": return MIOLocalizeString("CONCEPT", "CONCEPT");
        }
        return entityName;
    }

    setItem(link:BankMovementDocumentLink) {
        this._link = link;

        let cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter as MIONumberFormatter;
        this.typeLabel.text = BankMovementLinkCell.displayNameForLinkedEntity(link.linkedEntityName);
        this.nameLabel.text = link.documentNumber?.length > 0 ? link.documentNumber : (link.concept?.length > 0 ? link.concept : link.linkedEntityName);
        this.amountLabel.text = cf.stringFromNumber(link.amount);
        this.viewButton.hidden = BankMovementLinkCell.canViewLinkedEntity(link.linkedEntityName) == false;

        this.setExternalReference(null);
        if (link.linkedEntityName == "PurchaseInvoice" && link.linkedEntityID != null) this.loadExternalReference(link);
    }

    private setExternalReference(reference:string){
        this.externalLabel.text = reference != null ? "· " + reference : null;
        this.externalLabel.layer.title = reference != null ? MIOLocalizeString("EXTERNAL_REFERENCE", "External reference") + ": " + reference : "";
        this.externalLabel.hidden = reference == null;
    }

    private loadExternalReference(link:BankMovementDocumentLink){
        let id = link.linkedEntityID;
        let cache = BankMovementLinkCell.externalReferences;
        if (id in cache) { this.setExternalReference(cache[id]); return; }

        DBHelper.queryObjectWithCompletion("PurchaseInvoice", null, MIOPredicate.predicateWithFormat("identifier == " + id), [], this, function(this:BankMovementLinkCell, invoice:PurchaseInvoice){
            let reference = invoice?.externalReference;
            cache[id] = reference != null && reference.length > 0 ? reference : null;
            // the cell may show another link by now
            if (this._link?.linkedEntityID == id) this.setExternalReference(cache[id]);
        });
    }
}
